import Api from '../api/reconApi.js';
import * as getInfo from './apiGetInfo';
import * as AllMutates from './AllMutates';

export function startFeedScan(errorType) {
	// POST /api/feed_scans (openapi post_feed_scans_create) with bearer_auth.
	// Do not send X-Feed-Scan-Secret from the browser.
	return dispatch => Api.postNoBody('feed_scans').then((resp) => {
		// Immediate feedback that the button did something.
		dispatch(getInfo.getFeedScanSummary());

		// The scan lists and filters S3 before anything lands in the history.
		return new Promise((resolve) => {
			setTimeout(() => {
				dispatch(getInfo.getVehicleDataFeeds());
				dispatch(getInfo.getFeedLogs());
				dispatch(getInfo.getFeedScanSummary());
				resolve(resp);
			}, 5000);
		});
	}).catch((ex) => {
		Api.handleApiError(ex, errorType);
		throw ex;
	});
}

export function updateFeedProviders(id, data, errorType) {
	return dispatch => Api.patchData(`feed_providers/${id}`, data).then(() => {
		dispatch(getInfo.getFeedProviders());
	}).catch((ex) => {
		Api.handleApiError(ex, errorType);
		throw ex;
	});
}

export function addFeedProvider(data, errorType) {
	return (dispatch, getState) => Api.postData('feed_providers/', data).then(resp => dispatch(getInfo.getFeedProviders())).catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteFeedProvider(id, errorType) {
	return dispatch => Api.delete(`feed_providers/${id}`).then(() => {
		dispatch(getInfo.getFeedProviders());
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateFeedProviderRules(id, data, errorType) {
	return dispatch => Api.patchData(`feed_provider_rules/${id}`, data).then(() => {
		dispatch(getInfo.getFeedProviderRules());
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function addFeedProviderRule(data, errorType) {
	return (dispatch, getState) => Api.postData('feed_provider_rules/', data).then(resp => dispatch(getInfo.getFeedProviderRules())).catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteFeedProviderRule(id, errorType) {
	return dispatch => Api.delete(`feed_provider_rules/${id}`).then(() => {
		dispatch(getInfo.getFeedProviderRules());
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateFeedProviderSettings(id, data, errorType) {
	return dispatch => Api.patchData(`feed_provider_settings/${id}`, data).then(() => {
		dispatch(getInfo.getFeedProviderSettings());
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function addFeedProviderSetting(data, errorType) {
	return (dispatch, getState) => Api.postData('feed_provider_settings/', data).then(resp => dispatch(getInfo.getFeedProviderSettings())).catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteFeedProviderSetting(id, errorType) {
	return dispatch => Api.delete(`feed_provider_settings/${id}`).then(() => {
		dispatch(getInfo.getFeedProviderSettings());
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateFeedNotificationSettings(id, data, errorType) {
	return dispatch => Api.patchData(`feed_notification_settings/${id}`, data).then(() => {
		dispatch(getInfo.getFeedNotificationSettings());
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function addFeedNotificationSetting(data, errorType) {
	return (dispatch, getState) => Api.postData('feed_notification_settings/', data).then(resp => dispatch(getInfo.getFeedNotificationSettings())).catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteFeedNotificationSetting(id, errorType) {
	return dispatch => Api.delete(`feed_notification_settings/${id}`).then(() => {
		dispatch(getInfo.getFeedNotificationSettings());
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateFeedErrors(id, data, errorType) {
	return dispatch => Api.patchData(`feed_errors/${id}`, data).then(() => {
		dispatch(getInfo.getFeedErrors());
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function addFeedError(data, errorType) {
	return (dispatch, getState) => Api.postData('feed_errors/', data).then(resp => dispatch(getInfo.getFeedErrors())).catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteFeedError(id, errorType) {
	return dispatch => Api.delete(`feed_errors/${id}`).then(() => {
		dispatch(getInfo.getFeedErrors());
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}
